export const InventoryCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'B',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',

  HeaderRow: {
    flow: 'x',
    align: 'center flex-start',
    justifyContent: 'space-between',
    MaterialName: { text: (el, s) => s.name || '', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
    CategoryBadge: {
      tag: 'span',
      text: (el, s) => s.category || '',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'B',
      background: (el, s) => {
        const c = s.category
        if (c === 'Restorative') return 'blue.15'
        if (c === 'Endodontic') return 'purple.15'
        if (c === 'Prosthetic') return 'teal.15'
        if (c === 'Surgical') return 'red.15'
        if (c === 'Hygiene') return 'green.15'
        if (c === 'Disposables') return 'amber.15'
        return 'inkSurface'
      },
      color: (el, s) => {
        const c = s.category
        if (c === 'Restorative') return 'blue'
        if (c === 'Endodontic') return 'purple'
        if (c === 'Prosthetic') return 'teal'
        if (c === 'Surgical') return 'red'
        if (c === 'Hygiene') return 'green'
        if (c === 'Disposables') return 'amber'
        return 'inkMuted'
      }
    }
  },

  DetailsRow: {
    flow: 'x',
    gap: 'A',
    flexWrap: 'wrap',
    QtyInfo: {
      flow: 'y',
      gap: 'X',
      QtyLabel: { text: '{{ quantity | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      QtyValue: { text: (el, s) => `${s.quantity || 0} ${s.unit || ''}`, fontSize: 'Z', fontWeight: '700', color: 'inkText' }
    },
    ReorderInfo: {
      flow: 'y',
      gap: 'X',
      ReorderLabel: { text: '{{ reorderLevel | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      ReorderValue: { text: (el, s) => `${s.reorderLevel || 0} ${s.unit || ''}`, fontSize: 'Z', fontWeight: '600', color: 'inkMuted' }
    }
  },

  StockBar: {
    flow: 'y',
    gap: 'X',
    StockLabel: {
      flow: 'x',
      justifyContent: 'space-between',
      LevelText: { text: '{{ stockLevel | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Percent: { text: (el, s) => { const pct = s.maxCapacity ? Math.round((s.quantity / s.maxCapacity) * 100) : 0; return `${pct}%` }, fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }
    },
    BarTrack: {
      height: '6px',
      round: 'C',
      background: 'inkSurface',
      overflow: 'hidden',
      BarFill: {
        height: '100%',
        round: 'C',
        width: (el, s) => { const pct = s.maxCapacity ? Math.min(100, Math.round((s.quantity / s.maxCapacity) * 100)) : 0; return `${pct}%` },
        background: (el, s) => {
          const qty = s.quantity || 0
          const reorder = s.reorderLevel || 0
          if (qty <= reorder) return 'red'
          if (qty <= reorder * 1.5) return 'amber'
          return 'green'
        }
      }
    }
  },

  Divider: { height: '1px', background: 'inkBorder' },

  OrderBtn: {
    extends: 'Button',
    tag: 'button',
    text: '{{ orderNow | polyglot }}',
    background: 'teal',
    color: 'ink',
    fontWeight: '600',
    padding: 'Y A',
    round: 'A',
    fontSize: 'Y',
    cursor: 'pointer',
    border: 'none',
    alignSelf: 'flex-start'
  }
}
